import { render, staticRenderFns } from "./PageShowDynamic.vue?vue&type=template&id=8f5ed69e&"
import script from "./PageShowDynamic.vue?vue&type=script&lang=js&"
export * from "./PageShowDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports